var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.selectedNode.props.groups, function (group, index) {
        return _c("div", { key: index + "_g" }, [
          _c("div", { staticClass: "group-content" }, [
            group.conditions.length > 0
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "form-item-title" }, [
                      _vm._v("触发条件"),
                    ]),
                    _c(
                      "el-form",
                      { ref: "condition-form", refInFor: true },
                      _vm._l(group.conditions, function (condition, cindex) {
                        return _c(
                          "el-form-item",
                          { key: condition.id + "_" + cindex },
                          [
                            condition.valueType === _vm.ValueType.user
                              ? _c(
                                  "div",
                                  { staticClass: "item-condition" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(condition.title)),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-u",
                                        attrs: {
                                          "value-key": "name",
                                          placeholder: "添加发起人",
                                          size: "medium",
                                          multiple: "",
                                          "popper-class": "hidden",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.selectUser(
                                              condition.value
                                            )
                                          },
                                        },
                                        model: {
                                          value: condition.value,
                                          callback: function ($$v) {
                                            _vm.$set(condition, "value", $$v)
                                          },
                                          expression: "condition.value",
                                        },
                                      },
                                      _vm._l(
                                        condition.value,
                                        function (wc, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: wc.name,
                                              value: wc,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : condition.valueType === _vm.ValueType.dept
                              ? _c("span")
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ])
      }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickerTitle, multiple: "" },
        on: { ok: _vm.selected },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }